import type { FileIngestorState } from 'client/js/redux/domains/FileIngestor/FileIngestor.types';

export const INIT_STATE: FileIngestorState = {
  fileUri: null,
  jobs: [],
  pagination: {
    sort: {
      field: 'updated',
      order: 'DESC',
    },
    results_per_page: 10,
    total: 0,
  },
  jobDetails: null,
};
